<div class="bg-white p-4 border shadow-md rounded pr-28">
  <div class="font-bold mb-4">Closing Checklist</div>
  <div class="space-y-2.5 text-sm" *ngIf="(isLoadingList$ | async) === false">
    <div class="flex items-center" *ngFor="let workflow of workflowList$ | async; let i = index">
      <div
        class="w-6 h-6 border bg-aux-gray-light mr-2.5 rounded-full flex items-center justify-center"
      >
        {{ i + 1 }}
      </div>
      <div>
        <a class="aux-link" [routerLink]="'/' + workflow.properties.route">{{ workflow.name }}</a>
      </div>
    </div>
  </div>
  <div class="border-8 m-auto spinner h-16 w-16" *ngIf="isLoadingList$ | async"></div>
</div>
